<template>
    <div>
        <div
            class="container w-full max-w-full px-4 pb-[90px] pt-[20px] lg:max-w-[1000px] lg:px-0 lg:pb-[54px] lg:pt-[44px]"
        >
            <div
                class="relative aspect-[398/142] h-full w-full cursor-pointer md:aspect-[1000/290]"
                @click="onRedirectDeposit"
            >
                <img
                    :src="`${staticUrl}/assets/img/banner/euro/banner-3-pdp-${locale}.jpg`"
                    class="block rounded-md lg:rounded-none"
                    alt="image"
                />
            </div>
            <div class="mt-4 w-full lg:mt-6">
                <div
                    class="text-left text-lg font-semibold text-black lg:text-center"
                >
                    {{ $t('promotions.8_percent.title') }}
                </div>
            </div>
            <div class="my-3 lg:my-4">
                <div
                    class="sport-list grid grid-cols-3 gap-x-[14px] lg:gap-x-[36px]"
                >
                    <div
                        v-for="(sport, index) in listSport"
                        :key="index"
                        class="sport-item cursor-pointer hover:scale-105 lg:transition-all lg:duration-300 lg:hover:-translate-y-[2.3%]"
                        @click="redirect(sport)"
                    >
                        <img
                            :src="`${staticUrl}/assets/img/promotions/8-percent/${sport.image}`"
                            :alt="sport.id"
                        />
                    </div>
                </div>
            </div>
            <div class="text-sm font-normal text-black">
                <div class="mb-4 flex items-center gap-x-1 text-left">
                    <span class="font-bold">
                        {{ $t('promotions.8_percent.title_1') }}
                    </span>
                    <span>
                        {{ $t('promotions.8_percent.time') }}
                    </span>
                </div>
                <div class="mb-3 flex items-center text-left">
                    <span class="font-bold">
                        {{ $t('promotions.8_percent.title_2') }}
                    </span>
                </div>
                <ul class="mb-4">
                    <li v-for="(item, index) in list_1" :key="index">
                        {{ $t(item.title) }}
                    </li>
                </ul>
                <div class="mb-3 flex items-center text-left">
                    <span class="font-bold">
                        {{ $t('promotions.8_percent.title_3') }}
                    </span>
                </div>
                <ul class="mb-4">
                    <li v-for="(item, index) in list_2" :key="index">
                        {{ $t(item.title) }}
                    </li>
                </ul>
                <div class="mb-3 flex items-center text-left">
                    <span class="font-bold">
                        {{ $t('promotions.8_percent.title_4') }}
                    </span>
                </div>
                <ul class="mb-4">
                    <li v-for="(item, index) in list_3" :key="index">
                        {{ $t(item.title) }}
                    </li>
                </ul>
                <div class="flex items-center text-left">
                    <span class="font-bold">
                        {{ $t('promotions.8_percent.title_5') }}
                    </span>
                </div>
            </div>
            <div
                class="button-group mt-[24px] flex w-full items-center justify-center"
            >
                <ClientOnly>
                    <button
                        class="flex h-[48px] w-full items-center justify-center rounded bg-[#B01E46] md:w-[168px]"
                        :disabled="user?.package_id === 1"
                        @click="onRedirectDeposit"
                    >
                        <span class="text-sm font-medium text-white">{{
                            user?.package_id === 1
                                ? $t('promotions.banner.actived')
                                : $t('promotions.banner.deposit')
                        }}</span>
                    </button>
                </ClientOnly>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    useUserStore,
    useModalStore,
    useGamesStore,
    useSportsStore,
    useAlertStore,
} from '~/stores'
import { storeToRefs } from 'pinia'
const alertStore = useAlertStore()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()

const staticUrl = useRuntimeConfig().public.staticUrl
const { isLoggedIn, user } = storeToRefs(useUserStoreInstance)
const { showLoginModal } = storeToRefs(useModalStoreInstance)

const router = useRouter()
const { isMobile } = useDevice()
const { locale } = useI18n()
const listSport = ref([
    {
        key: 'ksport',
        link: '/tp/ksportUrl',
        name: 'K-SPORT',
        sub: 'ksport',
        title: 'sport',
        id: 'ksport',
        image: 'k-sport.png',
    },
    {
        key: 'saba-sport',
        link: '/athena/sportUrl',
        name: 'SABA',
        sub: 'saba',
        title: 'saba-sport',
        id: 'saba',
        image: 'saba.png',
    },
    {
        key: 'bti',
        link: '/btisports',
        name: 'BTI',
        sub: 'bti',
        title: 'bti-sport',
        id: 'bti',
        image: 'bti.png',
    },
])

const list_1 = ref([
    {
        key: 1,
        title: 'promotions.8_percent.list_1.item_1',
    },
    {
        key: 2,
        title: 'promotions.8_percent.list_1.item_2',
    },
    // {
    //     key: 3,
    //     title: 'promotions.8_percent.list_1.item_3',
    // },
    {
        key: 4,
        title: 'promotions.8_percent.list_1.item_4',
    },
    {
        key: 5,
        title: 'promotions.8_percent.list_1.item_5',
    },
])
const list_2 = ref([
    {
        key: 1,
        title: 'promotions.8_percent.list_2.item_1',
    },
    {
        key: 2,
        title: 'promotions.8_percent.list_2.item_2',
    },
])
const list_3 = ref([
    {
        key: 1,
        title: 'promotions.8_percent.list_3.item_1',
    },
    {
        key: 2,
        title: 'promotions.8_percent.list_3.item_2',
    },
])

const gameStoreInstance = useGamesStore()
const useSportsStoreInstance = useSportsStore()
const { getGameUrl } = gameStoreInstance
const { getSportUrl } = useSportsStoreInstance
const { t } = useI18n({})

const handleGetGameUrl = async (toSend) => {
    try {
        if (isMobile) {
            const { data } = await getGameUrl(toSend)
            if (data.value.status === 'OK') {
                const { url } = data.value.data
                setTimeout(() => {
                    const popup = window.open(url, '_blank')
                    if (!popup) {
                        alertStore.showMessageError({
                            value: {
                                statusCode: 'SHOW_MESSAGE',
                                message: t('error.allow_popup'),
                            },
                        })
                    }
                })
                return
            }
        }
        router.push('/btisports')
    } catch (error) {
        alertStore.showMessageError(error)
    }
}
const sportRoute = {
    '/tp/ksportUrl': '/ksports',
    '/athena/sportUrl': '/osports',
    '/tp/tsportUrl': '/tsports',
    '/tp/ssportUrl': '/ssports',
}

const routeToSport = (payload) => {
    if (sportRoute[payload]) {
        router.push(sportRoute[payload])
    }
}
const redirect = async (item) => {
    if (item.key === 'bti') {
        if (!isLoggedIn.value) {
            useModalStoreInstance.showLoginModal = true
            return
        }
        const toSend = {
            partnerProvider: 'bti',
        }
        handleGetGameUrl(toSend)
        return
    }
    if (isMobile) {
        const { data } = await getSportUrl(item.link)
        setTimeout(() => {
            const popup = window.open(data?.data?.url, '_blank')
            if (!popup) {
                alertStore.showMessageError({
                    value: {
                        statusCode: 'SHOW_MESSAGE',
                        message: t('error.allow_popup'),
                    },
                })
            }
        })
        return
    }
    routeToSport(item.link)
}

const onLoginClick = () => {
    showLoginModal.value = true
}

const onRedirectDeposit = () => {
    if (!isLoggedIn.value) {
        onLoginClick()
        return
    }
    window.location.href = '/account/deposit?package_id=1'
}
</script>

<style lang="scss" scoped>
ul {
    li {
        position: relative;
        padding-left: 16px;
        margin-bottom: 6px;
        &::before {
            content: '';
            position: absolute;
            left: 4px;
            top: 8px;
            width: 4px;
            height: 4px;
            background-color: #000;
            border-radius: 50%;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
}

.text-gradient {
    background: linear-gradient(30.43deg, #fff2ae 14.6%, #f7d936 70.33%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
